import { UserRoles } from "@/lib/types/user-roles";
import type { GetUserBaseResponse } from "@/openapi/generated/models";

export const SIGNUP_EMAIL_STATUS = {
  new: "new",
  existingStudio: "existing_studio",
  existingMember: "existing_member",
} as const;

export type SignupEmailStatus =
  (typeof SIGNUP_EMAIL_STATUS)[keyof typeof SIGNUP_EMAIL_STATUS];

export const EXISTING_STUDIO_SIGNUP_MESSAGE =
  "An account with this email already exists in the admin portal. Use the password you created there — you don't need a new one.";

export const EXISTING_MEMBER_SIGNUP_MESSAGE =
  "An account with this email already exists. Please sign in.";

export const EXISTING_STUDIO_SIGNIN_MESSAGE =
  "Parent access was added to your existing account. Sign in with the password you created in the admin portal.";

function normalizeRoles(roles: Array<string> | null | undefined): string[] {
  return (roles ?? []).map((role) => role.trim().toLowerCase());
}

export function classifySignupEmailUser(
  user: GetUserBaseResponse | null | undefined,
): SignupEmailStatus {
  if (user == null || user.userId == null) {
    return SIGNUP_EMAIL_STATUS.new;
  }

  const roles = normalizeRoles(user.roles);
  if (roles.includes(UserRoles.Member.toLowerCase())) {
    return SIGNUP_EMAIL_STATUS.existingMember;
  }

  return SIGNUP_EMAIL_STATUS.existingStudio;
}

export function isExistingStudioSignup(
  status: SignupEmailStatus | null | undefined,
): boolean {
  return status === SIGNUP_EMAIL_STATUS.existingStudio;
}
